<script setup lang="ts">

import {computed, ref, watch} from "vue";

const emit = defineEmits(['changed']);

const data = ref({
    prefix: 'ABC',
    start: 1,
    step: 2,
    limit: 100
})

const exampleSerial = computed(() => {
    if (!validateData()) {
        return "Заполните поля, чтобы увидеть превью серии";
    }

    const end = serialLength() * data.value.step + data.value.start*1
    return data.value.prefix + data.value.start + "... (шаг " + data.value.step + ") ..." + data.value.prefix + end + " (всего "+ serialLength() +"шт.)"
})

const serialLength = () => {
    return Math.floor((data.value.limit*1 - data.value.start*1) / data.value.step)
}

const validateData = () => {
    if (data.value.prefix.length <= 0) {
        return false
    }

    if (data.value.start.length == 0 || data.value.start < 0) {
        return false
    }

    if (data.value.step == 0 || data.value.step < 0) {
        return false
    }

    if (data.value.limit == 0 || data.value.limit < data.value.start + data.value.step) {
        return false
    }

    return true;
}

emit('changed', data.value)
watch(data, () => {
    emit('changed', data.value)
}, { deep: true })


</script>

<template>
    <div>
        <div class="rounded-md bg-blue-50 p-4">
            <div class="flex">
                <div class="ml-3">
                    <div>
                        <div>
                            Например, чтобы создать серию QR-кодов с серийными кодами — ABCD0005, ABCD0007, …, ABCD0097,
                            ABCD0099, выполните следующие шаги:
                        </div>

                        <ul class="mt-2">
                            <li>
                                1. В поле <strong>Префикс</strong> добавьте «ABCD00». Это фиксированное текстовое или
                                числовое значение перед серией.
                            </li>
                            <li>
                                2. В поле <strong>Старт</strong> введите «5», это начальное значение серии.
                            </li>
                            <li>
                                3. В поле <strong>Шаг</strong> укажите «2», это фиксированное увеличение серии.
                            </li>
                            <li>
                                4. В поле <strong>Лимит</strong> введите «99», это последнее значение серии.
                            </li>
                        </ul>

                        <div class="mt-2">
                            <strong>Важное примечание:</strong> Количество цифр в поле End должно быть равно или больше
                            количества цифр в
                            поле Start. Лишние ведущие нули в поле End, а также соответствующие нули в поле Start будут
                            удалены автоматически.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="border flex p-2 mt-2 font-bold border-dashed">
            {{ exampleSerial }}
        </div>

        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 mt-4">
            <div class="sm:col-span-4">
                <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Префикс</label>
                <div class="mt-2">
                    <div
                        class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                        <input type="text" name="email" id="email" v-model="data.prefix"
                               class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>
            </div>

            <div class="sm:col-span-4">
                <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Старт</label>
                <div class="mt-2">
                    <div
                        class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                        <input type="number" name="email" id="email" v-model="data.start"
                               class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>
            </div>

            <div class="sm:col-span-4">
                <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Шаг</label>
                <div class="mt-2">
                    <div
                        class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                        <input type="number" name="email" id="email" v-model="data.step"
                               class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>
            </div>

            <div class="sm:col-span-4">
                <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Лимит</label>
                <div class="mt-2">
                    <div
                        class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                        <input type="number" name="email" id="email" v-model="data.limit"
                               class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>